import type { RatingLane as RatingLaneKey } from "@nlc/shared-types";
import type { Dispatch, SetStateAction } from "react";

import { useState } from "react";

export type LanesState = Record<
  RatingLaneKey,
  { chips: string[]; stars: number }
>;

export const emptyLanes: LanesState = {
  design: { chips: [], stars: 0 },
  platform: { chips: [], stars: 0 },
  team: { chips: [], stars: 0 },
};

export function useRatingLanes(): {
  lanes: LanesState;
  setLanes: Dispatch<SetStateAction<LanesState>>;
  setStars: (lane: RatingLaneKey, stars: number) => void;
  toggleChip: (lane: RatingLaneKey, chip: string) => void;
} {
  const [lanes, setLanes] = useState<LanesState>(emptyLanes);

  const setStars = (lane: RatingLaneKey, stars: number) =>
    setLanes((state) => ({ ...state, [lane]: { chips: [], stars } }));

  const toggleChip = (lane: RatingLaneKey, chip: string) =>
    setLanes((state) => ({
      ...state,
      [lane]: {
        ...state[lane],
        chips: state[lane].chips.includes(chip)
          ? state[lane].chips.filter((c) => c !== chip)
          : [...state[lane].chips, chip],
      },
    }));

  return { lanes, setLanes, setStars, toggleChip };
}
